<div class="summary-success">
  <div class="summary-success-title">
    <div class="summary-success-title-data" *ngIf="!!isf">
      <div class="title-block" *ngIf="isf.referenceNumber">
        <div class="title-block-data">{{ "LABELS.EEZY_ID" | translate }}</div>
        <div class="title-block-text">
          <strong>{{ isf.referenceNumber }}</strong>
        </div>
      </div>

      <div class="title-block pl-3">
        <div class="title-block-data" *ngIf="isf.transactionNumber">{{ "LABELS.CBP_ID" | translate }}</div>
        <div class="title-block-text" *ngIf="isf.transactionNumber">
          <strong>{{ isf.transactionNumber }}</strong>
        </div>
      </div>

      <div class="title-block pl-3" *ngIf="isf?.sentToProviderDate || isf.receivedByCbpDate">
        <div class="title-block-data">
          {{
            (isf.receivedByCbpDate
              ? isDeletedStatus
                ? "LABELS.DELETED_BY_CBP"
                : "STATUS.SECOND_TEXT.RECEIVED_BY_CBP"
              : "LABELS.SENT_TO_PROVIDER"
            ) | translate
          }}
        </div>
        <div class="title-block-text">
          <strong>{{ (isf.receivedByCbpDate ? isf.receivedByCbpDate : isf.sentToProviderDate) | customDateByUtc }}</strong>
        </div>
      </div>
    </div>
    <div class="summary-success-title-actions">
      <span
        *ngIf="isShowEditIcon && isShowEditButton"
        class="summary-success-title-actions-item"
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipOverlayClassName="tooltip-sm"
        [nzTooltipTitle]="'BUTTON.EDIT' | translate"
        (click)="edit.emit()"
      >
        <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
          />
        </svg>
      </span>

      <span
        *ngIf="isShowDuplicateIcon && isShowDuplicateButton"
        class="summary-success-title-actions-item"
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipOverlayClassName="tooltip-sm"
        [nzTooltipTitle]="'BUTTON.DUPLICATE' | translate"
        (click)="onDuplicateClick()"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 0H18C19.103 0 20 0.897 20 2V14H18V2H6V0ZM2 20H14C15.103 20 16 19.103 16 18V6C16 4.897 15.103 4 14 4H2C0.897 4 0 4.897 0 6V18C0 19.103 0.897 20 2 20ZM2 6H14L14.002 18H2V6ZM9 8H7V11H4V13H7V16H9V13H12V11H9V8Z"
          />
        </svg>
      </span>

      <span class="summary-success-title-actions-item" *ngIf="isShowInsuranceIndicator">
        <app-marine-insurance-indicator
          [isPlain]="true"
          [isOnEntityPage]="true"
          (addInsurance)="addInsurance.emit()"
          [entityReferenceNumber]="isf.referenceNumber"
          entityRedirectPath="/isf"
          [companyPlacement]="enumCompanyPlacement.ISF"
          [entityStatus]="isf.insuranceStatus"
        ></app-marine-insurance-indicator>
      </span>

      <span
        class="summary-success-title-actions-item"
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipOverlayClassName="tooltip-sm"
        [nzTooltipTitle]="'BUTTON.PRINT' | translate"
        (click)="print.emit()"
      >
        <svg width="20" height="18" viewBox="0 0 20 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.7472 0C14.0426 0 14.335 0.058198 14.6079 0.171271C14.8808 0.284344 15.1288 0.450078 15.3376 0.65901C15.5465 0.867942 15.7122 1.11598 15.8252 1.38896C15.9382 1.66194 15.9964 1.95453 15.9964 2.25V3.003H16.7461C17.6078 3.00353 18.4341 3.34604 19.0436 3.95537C19.653 4.56469 19.9959 5.39103 19.997 6.253L20 12.25C20.0001 12.5453 19.9421 12.8378 19.8292 13.1107C19.7164 13.3836 19.5509 13.6316 19.3422 13.8406C19.1335 14.0495 18.8858 14.2153 18.6131 14.3284C18.3403 14.4416 18.048 14.4999 17.7528 14.5H15.9944V15.75C15.9944 16.3467 15.7574 16.919 15.3356 17.341C14.9138 17.7629 14.3417 18 13.7452 18H6.24781C5.65128 18 5.07919 17.7629 4.65738 17.341C4.23557 16.919 3.9986 16.3467 3.9986 15.75V14.5H2.24921C1.65268 14.5 1.08059 14.2629 0.658779 13.841C0.23697 13.419 0 12.8467 0 12.25V6.254C0 5.39205 0.34229 4.5654 0.95157 3.9559C1.56085 3.34641 2.38721 3.004 3.24886 3.004L3.9976 3.003L3.9986 2.25C3.9986 1.65326 4.23557 1.08097 4.65738 0.65901C5.07919 0.237053 5.65128 0 6.24781 0H13.7472V0ZM13.7452 10.5H6.24781C6.04897 10.5 5.85827 10.579 5.71767 10.7197C5.57707 10.8603 5.49808 11.0511 5.49808 11.25V15.75C5.49808 16.164 5.83396 16.5 6.24781 16.5H13.7452C13.944 16.5 14.1347 16.421 14.2753 16.2803C14.4159 16.1397 14.4949 15.9489 14.4949 15.75V11.25C14.4949 11.0511 14.4159 10.8603 14.2753 10.7197C14.1347 10.579 13.944 10.5 13.7452 10.5V10.5ZM16.7461 4.504H3.24886C2.7849 4.504 2.33993 4.68837 2.01186 5.01656C1.68379 5.34475 1.49948 5.78987 1.49948 6.254V12.25C1.49948 12.664 1.83536 13 2.24921 13H3.9986V11.25C3.9986 10.6533 4.23557 10.081 4.65738 9.65901C5.07919 9.23705 5.65128 9 6.24781 9H13.7452C14.3417 9 14.9138 9.23705 15.3356 9.65901C15.7574 10.081 15.9944 10.6533 15.9944 11.25V13H17.7768C17.971 12.9935 18.1551 12.9117 18.2901 12.772C18.4252 12.6322 18.5006 12.4454 18.5005 12.251L18.4975 6.254C18.4965 5.78985 18.3115 5.34504 17.9833 5.01702C17.655 4.68901 17.2101 4.50453 16.7461 4.504V4.504ZM13.7472 1.5H6.24781C6.04897 1.5 5.85827 1.57902 5.71767 1.71967C5.57707 1.86032 5.49808 2.05109 5.49808 2.25L5.49708 3.003H14.4969V2.25C14.4969 2.05109 14.4179 1.86032 14.2773 1.71967C14.1367 1.57902 13.946 1.5 13.7472 1.5V1.5Z"
          />
        </svg>
      </span>

      <span
        class="summary-success-title-actions-item"
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipOverlayClassName="tooltip-sm"
        [nzTooltipTitle]="'BUTTON.CBP_LOG' | translate"
        (click)="openCBP()"
      >
        <svg width="20" height="10" viewBox="0 0 20 10" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16 0C14.9 0 14 0.9 14 2V8C14 9.1 14.9 10 16 10H18C19.1 10 20 9.1 20 8V4H18V8H16V2H20V0H16ZM0 0V10H6V8H2V0H0ZM9 0C7.9 0 7 0.9 7 2V8C7 9.1 7.9 10 9 10H11C12.1 10 13 9.1 13 8V2C13 0.9 12.1 0 11 0H9ZM9 2H11V8H9V2Z"
          />
        </svg>
      </span>

      <span
        class="summary-success-title-actions-item"
        *ngIf="isShowCreateESIcon && isShowCreateEsButton"
        nz-tooltip
        nzTooltipColor="#ffffff"
        nzTooltipOverlayClassName="tooltip-sm"
        [nzTooltipTitle]="'BUTTON.CREATE_ES' | translate"
        (click)="createES.emit()"
      >
        <svg width="20" height="23" viewBox="0 0 20 23" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20 7.00993L10 0.834488L0 7.00993L10 13.1854L20 7.00993ZM18.0968 7.00993L10 2.0098L1.90321 7.00993L10 12.0101L18.0968 7.00993Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 13.7431L1 8.80279V15.6965L9 20.3281V13.7431ZM10 13.1854L0 7.00993V16.2731L10 22.0626V13.1854Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20 7.00993L10 13.1854V22.0626L20 16.2731L20 7.00993ZM19 8.80281L11 13.7432V20.3281L19 15.6966V8.80281Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 2.41319L2 7.35354V15.12L10 19.7516L18 15.12V7.35354L10 2.41319ZM20 6.238L10 0.062561L0 6.238V16.2731L10 22.0626L20 16.2731L20 6.238Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.66256 3.50667L14.8933 9.6821L14.3373 10.5133L5.10651 4.33782L5.66256 3.50667Z"
          />
        </svg>
      </span>
    </div>
  </div>

  <div class="summary-success-body">
    <div
      class="summary-success-body-notifications"
      [ngClass]="{ warning: isWarningNotification || isPaymentPending, success: isSuccessNotification }"
      *ngIf="isShowNotification || isShowSuccessNotification || isPaymentPending"
    >
      <div class="summary-success-body-notifications-header" *ngIf="isEditMode">
        <h3>{{ notificationHeader | translate }}</h3>

        <span (click)="closeNotification.emit()">
          <i class="fa fa-times"></i>
          {{ notificationHeaderAction | translate }}
        </span>
      </div>
      <div class="summary-success-body-notifications-body">
        <div class="summary-success-body-notifications-body-icon">
          <span [ngClass]="{ 'icon-ic_big_v': isSuccessNotification, 'icon-ic_big_a': isWarningNotification || isPaymentPending }"></span>
        </div>
        <div class="summary-success-body-notifications-body-text"><p [innerHTML]="notificationBody | translate"></p></div>
      </div>
    </div>

    <div class="summary-success-body-notifications warning" *ngIf="entityCsOrLgText">
      <div class="summary-success-body-notifications-body">
        <div class="summary-success-body-notifications-body-icon">
          <span class="icon-ic_big_a"></span>
        </div>
        <div class="summary-success-body-notifications-body-text">
          <p [innerHTML]="'MAKE_SURE_TO_COMPLETE_CS_LG' | translate : { entityText: entityCsOrLgText }"></p>
        </div>
      </div>
    </div>

    <div class="summary-success-body-text">
      <div class="summary-success-body-text-description">
        <div class="summary-success-body-text-description-t">
          <span [innerHTML]="summaryBodyText | translate"></span>

          <div *ngIf="isShowLoader" class="loader-wrapper">
            <img src="/assets/images/loading.gif" />
          </div>

          <ul *ngIf="messages.length" class="messages-list">
            <li *ngFor="let message of messages" class="messages-item">
              <span *ngIf="showTranslatedKey(message)" [innerHTML]="message.key | translate : message.params"></span>
              <span *ngIf="registerMessage(message)">
                {{
                  registerMessage(message)
                    | translate : { code: "LABELS.ISF" | translate, entityType: getEntityTypeText(message) | translate }
                }}
              </span>
            </li>
          </ul>
        </div>
        <span class="btn-contact-support" *ngIf="isShowSupportBtn" (click)="contactSupport()">
          <svg width="18" height="14" viewBox="0 0 18 14" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.28746e-05 4.5L0 14H13.5C15.9853 14 18 11.3895 18 8.90425V4.5C18 2.01472 15.9853 0 13.5 0H4.50001C2.01473 0 1.28746e-05 2.01472 1.28746e-05 4.5ZM3 5C3 4.44772 3.44772 4 4 4H14C14.5523 4 15 4.44772 15 5C15 5.55228 14.5523 6 14 6H4C3.44772 6 3 5.55228 3 5ZM4 8C3.44772 8 3 8.44771 3 9C3 9.55229 3.44772 10 4 10H11C11.5523 10 12 9.55229 12 9C12 8.44771 11.5523 8 11 8H4Z"
              fill="currentColor"
            />
          </svg>

          {{ "BUTTON.CONTACT_SUPPORT_ISF_ES" | translate }}
        </span>
      </div>

      <div class="summary-success-body-cbp-log" *ngIf="isCBPOpen">
        <desktop-isf-summary-cbp-log [messageList]="cbpLogMessages" (close)="openCBP()"></desktop-isf-summary-cbp-log>
      </div>
    </div>
  </div>
</div>

<poa-required-modal [(open)]="showPoaRequiredModal" (discard)="onPoaModalDiscard()" (goToPoa)="onPoaModalGoToPoa()"></poa-required-modal>
